<template>
  <f7-page id="transaction-modify-page" name="transaction-modify-page" @page:beforein="showHideInput" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>
      <div class="mt-xl row">
        <div class="wandr-title-1 wandr-level-4">{{$t('my-transaction-edit-transaction-details')}}</div>
      </div>
    </f7-block>

    <transition name="fade">
      <f7-card
        :title  ="alertCard.title"
        class   ="alert alert-danger margin"
        v-show  ="alertCard.show"
      >
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>
    </transition>

    <div class="block">

      <f7-list class="form-group">
        <div class="mb-md text-color-gray b">
          {{$t('sendmoney-text-exchange-rate')}} <span class="text-color-black">1 {{hostCurrency}}  =  {{activeDisplayRate}} {{homeCurrency}}</span>
        </div>

        <!-- HOST AMOUNT INPUT -->
        <f7-list-input
          input-id      ="input-host-amount"
          name          ="input-host-amount"
          type          ="text"
          class         ="amount fx-amount-row host-amount"
          :label        ="$t('sendmoney-label-you-send')"
          autocomplete  ="off"
          pattern       ="[0-9]*"
          inputmode     ="decimal"
          outline
          floating-label
          required
          :disabled    ="true"
          :value        ="this.formatCurrency(transaction.hostAmount, 2) || 0"
        >
          <div slot="media" class="currency-code">
            <img :src="require('@/assets/img/flags/flag_rect_'+hostCountryId+'.png')" />
            {{hostCurrency}}
          </div>
        </f7-list-input>

        <!-- HOME AMOUNT INPUT -->
        <f7-list-input
          input-id      ="input-home-amount"
          name          ="input-home-amount"
          type          ="text"
          class         ="amount fx-amount-row mb-22"
          autocomplete  ="off"
          pattern       ="[0-9]*"
          inputmode     ="decimal"
          :label        ="$t('sendmoney-label-recipient-receives')"
          outline
          floating-label
          required
          :disabled     ="true"
          :value        ="this.formatCurrency(transaction.homeAmount, 2) || 0"
          >
          <div slot="media" class="currency-code">
            <img :src="require('@/assets/img/flags/flag_rect_'+homeCountryId+'.png')" />
            {{homeCurrency}}
          </div>
        </f7-list-input>
      </f7-list>


      <TransactionBillPayment
        @validateInput="validateInput"
        @setInput="setInput"
      />

      <TransactionBasic
        @changeHomePhoneCode="changeHomePhoneCode"
        @changeMobilePhoneCode="changeMobilePhoneCode"
        @changePaymentPurpose="changePaymentPurpose"
        @validateInput="validateInput"
        @setInput="setInput"
      />

      <TransactionPaymentPurpose v-if="isShowPaymentPurpose"
          :key="forceRerenderKey.componentPaymentPurposeKey"
          @changePaymentPurpose="changePaymentPurpose"
          @validateInput="validateInput"
          @setInput="setInput"
      />

      <TransactionBasic2
        @changeIdType="changeIdType"
        @validateInput="validateInput"
        @setInput="setInput"
      />

      <TransactionDoorToDoor
        @validateInput="validateInput"
        @setInput="setInput"
      />

      <TransactionRefNo
        @validateInput="validateInput"
        @setInput="setInput"
      />

      <f7-button large fill @click="modifyTransaction()" :disabled="isFormInputValid ? false : true" class="view-desktop mt-5">
        {{$t('beneficiary-btn-save')}}
      </f7-button>
      <f7-button v-show="isShowCancel" class="view-desktop mt-md color-gray6 text-color-red" large fill @click="showCancelTrxModal=true" :disabled="false">
        {{$t('my-transaction-btn-cancel-trx')}}
      </f7-button>
    </div>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button view-mobile">
      <f7-button large fill @click="modifyTransaction()" :disabled="isFormInputValid ? false : true">
        {{$t('beneficiary-btn-save')}}
      </f7-button>
      <f7-button v-show="isShowCancel" class="color-gray6 text-color-red" large fill @click="showCancelTrxModal=true" :disabled="false">
        {{$t('my-transaction-btn-cancel-trx')}}
      </f7-button>
    </f7-toolbar>

    <f7-sheet class="wandr-sheet-modal sheet-center sheet-24" :opened="showCancelTrxModal" @sheet:closed="showCancelTrxModal= false" :swipeToClose="true">
      <div class="modal-subtitle mb-md text-align-center">{{$t('sendmoney-cancel-transaction-confirm')}}</div>
      <div>
        <f7-button class="mt-22" large fill @click="cancelTransaction()">{{$t('my-transaction-cancel-tx')}}</f7-button>
        <f7-button class="mt-22" large outline @click="showCancelTrxModal= false">{{$t('my-transaction-back-tx-detail')}}</f7-button>
      </div>
    </f7-sheet>

  </f7-page>
</template>

<script>

  import { mapGetters, mapActions } from "vuex";
  import TransactionBillPayment from '../../components/transaction-bill-payment.vue';
  import TransactionBasic from '../../components/transaction-basic.vue';
  import TransactionBasic2 from '../../components/transaction-basic-2.vue';
  import TransactionDoorToDoor from '../../components/transaction-door-to-door.vue';
  import TransactionRefNo from '../../components/transaction-ref-no.vue';
  import TransactionPaymentPurpose from '../../components/transaction-payment-purpose.vue';
  import store from '../../store';
  import {fxRateHelper as FX } from '@/plugins/helper';


  export default {
    mounted() {
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
         this.toggleFooterVisibility(e.target)
      })

      //this.transactionId                = this.$store.state.transaction.transactionId;
      //this.transactionTypeId            = this.$store.state.transaction.transactionTypeId;

      this.loadTransactionDetails();
      this.init();
    },

    data() {
       return {
          transaction            : [],
          isShowPaymentPurpose   : true,
          beneName               : "",
          isShowCancel        : false,
          showCancelTrxModal  : false,
          activeDisplayRate   : 0,
        }
    },


    components: {
      TransactionBillPayment,
      TransactionBasic,
      TransactionBasic2,
      TransactionDoorToDoor,
      TransactionRefNo,
      TransactionPaymentPurpose,
    },

    computed: {
      ...mapGetters('auth', [
          'authenticating',
          'authenticationError',
          'authenticationErrorCode',
          'authenticationSuccess'
      ]),

      ...mapGetters('transaction', [

        'bankAccountNo',
        'bankAccountName',
        'bankAccountNoLabel',
        'bankId',
        'bankTypeId',
        'bankName',
        'bankNameLabel',
        'bankNamePlaceholder',
        'beneficiaryId',
        'beneficiaryName',
        'beneficiaryNameLabel',
        'beneficiaryTypeId',
        'billCorporationName',


        'countryCodeList',

        'deliveryMethod',
        'deliveryMethodId',
        'dmExternalName',
        'email',
        'emailLabel',

        'homeCountryId',
        'homeCountryIdd',
        'homeCountryList',
        'homeCountryName',
        'homeCurrencyId',
        'homeCurrency',
        'homeIDD',
        'homeIDDCode',
        'homeNo',
        'hostCountryId',
        'hostCountryName',
        'hostCurrencyId',
        'hostCurrency',

        'identificationNo',
        'identificationNoLabel',
        'identificationType',
        'identificationTypeLabel',
        'idTypeList',
        'idTypeSelect',
        'idTypeSelectId',

        'isbKashTx',
        'isCreateBeneficiary',
        'isDisplayErrorMsg',
        'isFormInputValid',
        'landmark',
        'locatingNote',
        'mobileIDD',
        'mobileIDDCode',
        'mobileNo',
        'mobileNoLabel',

        'paymentPurpose',
        'paymentPurposeId',
        'paymentPurposeList',
        'paymentPurposeOther',
        'postcode',
        'radioErrorMsg',
        'refNo',
        'refNoLabel',
        'settlementStatusId',
        'street',
        'streetLabel',
        'transactionId',
        'transactionTypeId',
        'validateInputState',
        'forceRerenderKey',
        'showFormSet',
        'showFormInput',
        'alertCard',
        'walletNo',

      ])
    },

        methods: {
          ...mapActions('auth', ['login']),
          ...mapActions('transaction', [
            'displayBillPayment', 'displayCollection', 'displayDoorToDoor','displayPostcode', 'displayBeneficiaryName', 'displayIdType',
            'displayIdTypeSelect', 'displayIdNo', 'displayAccountNo', 'displayRefNo','displayPaymentPurpose', 'displayPaymentPurposeOther',
            'displayHomeNo', 'displayMobileNo','displayEmail', 'validateBeneficiaryName','validateIdentificationType', 'validateIdTypeSelect',
            'validateIdentificationNo', 'validateStreet', 'validatePostcode', 'validateAccountNo','validateRefNote', 'validatePaymentPurpose',
            'validateHomeNo', 'validateMobileNo','validateEmail',

            'setHomeCountryList', 'setIdTypeSelect','setIdTypeList','setBankAccountNoLabel','setEmailLabel','setBankAccountNo','setHostCountry','setHomeCountry', 'setBankTypeId',
            'setPaymentPurpose','setPaymentPurposeOther','setPaymentPurposeList','setBillCorporationList','setCountryCodeList','setStreet','setStreetLabel',
            'setPostcode', 'setLocatingNote', 'setLandmark','setRadioErrorMsg','setHomeIDD','setMobileIDD','setBeneficiaryName','setShowFormInputPaymentPurposeOther',
            'setIsDisplayErrorMsg','changeHomePhoneCode','changeMobilePhoneCode','setIsFormInputValid','setForceRerenderKey','setValidateInputState',
            'changeIdType','changePaymentPurpose','changeBillCorp','setIdentificationNo','setIdentificationType','setRefNo','setHomeNo','setMobileNo','setProvinceList',
            'setEmail','setDeliveryMethod','setDmExternalName','setIsCreateBeneficiary','setTransactionType','resetFormData','resetDataStore','showHideInput','validateInput',
            'resetBeneficiaryState','finalValidatePostcode','finalValidatePaymentPurpose','finalValidateHomePhone','finalValidateMobilePhone','loadCityList',
              'loadPostCity','setBeneficiaryTypeId','setHostCurrency','setHomeCurrency','setBankAccountName', 'setWalletNo', 'loadIsDisplayWalletNo', 'loadIsDisplayAccountNo',
          ]),

          afterin(){
            window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
          },
          async loadTransactionDetails() {
            const self        = this;

            self.showPreloader();

            let trxPromise = {};
            if(self.transactionTypeId == 1){
              trxPromise = await this.$api.transaction.getBillPayment(self.transactionId)
            } else{
              trxPromise = await this.$api.transaction.getRemittance(self.transactionId)
            }

            self.hidePreloader();

            self.transaction  = trxPromise;
            console.log("transaction: ", self.transaction)

            self.initializeValues()

            console.log("TRANSACTION AFTER SET", this.$store.state.transaction);

            await self.loadForm();
            self.hidePreloader();

          },

          async initializeValues(){
            const self        = this;
            
            self.activeDisplayRate    = FX.formatDisplayRate(self.transaction.exchangeRate, {countryId: self.transaction.homeCountryId, isDisplay: true})
            self.setBeneficiaryName(self.transaction.beneficiary.firstName == undefined ? self.transaction.beneficiaryBankAccountName: self.transaction.beneficiary.firstName);
            self.setBeneficiaryTypeId(self.transaction.beneficiary.beneficiaryTypeId);

            // GET HOME COUNTRY LIST
            const homeCountryPromise     = await self.$api.beneficiary.getCountryList();
            self.setHomeCountryList(homeCountryPromise);

            let homeCountryIddTmp = "";
            Object.keys(self.homeCountryList).forEach(key => {
                if(self.homeCountryList[key].id == self.transaction.homeCountryId) {
                    homeCountryIddTmp = self.homeCountryList[key].idd
                    return;
                }
            })

            console.log("HOME COUNTRY IDD : "+homeCountryIddTmp)

            self.setHostCountry({id: self.transaction.hostCountryId, name: self.transaction.hostCountry});
            self.setHomeCountry({id: self.transaction.homeCountryId, idd: homeCountryIddTmp, name: self.transaction.homeCountry});
            self.setHostCurrency({id: self.transaction.hostCurrencyId, name: self.transaction.hostCurrency});
            self.setHomeCurrency({id: self.transaction.homeCurrencyId, name: self.transaction.homeCurrency});
            self.setDeliveryMethod({id: self.transaction.deliveryMethodId, name: self.transaction.deliveryMethod});
            //self.setBank({id: self.transaction.beneficiaryBankId, name: self.transaction.beneficiaryBank});
            self.setBankTypeId(self.transaction.bankTypeId);

            self.setPostcode(self.transaction.beneficiary.address.postcode);
            self.setStreet(self.transaction.beneficiary.address.streetAddress);
            self.setLandmark(self.transaction.beneficiary.address.buildingName);
            self.setLocatingNote(self.transaction.beneficiary.address.unitNumber);

            self.setIdentificationNo(self.transaction.beneficiary.identificationNo);
            self.setIdentificationType(self.transaction.beneficiary.identificationType);
            if(self.transactionTypeId == 1){ //bill payment
              self.setBankAccountNo(self.transaction.billAccountNo);
            }else{
              self.setBankAccountNo(self.transaction.beneficiaryBankAccountNo);

              // DR-1438 : do not substring for PH Gcash
              const walletNumber = self.transaction.homeCountryId == 167 ? self.transaction.beneficiaryBankAccountNo : self.transaction.beneficiaryBankAccountNo.substring(self.mobileIDDCode.length-1)
              self.setWalletNo(walletNumber);
            }
            if(self.transactionTypeId == 1){ //bill payment
              self.setBankAccountName(self.transaction.billAccountName == undefined ? self.transaction.beneficiary.bankAccountName : self.transaction.billAccountName);

            }else{
              self.setBankAccountName(self.transaction.beneficiaryBankAccountName == undefined ? self.transaction.beneficiary.bankAccountName : self.transaction.beneficiaryBankAccountName);
            }

            self.setEmail(self.transaction.beneficiary.email);


            self.setHomeIDD({
              id: self.transaction.beneficiary.phoneOperatorCountryId == 0 ? self.transaction.homeCountryId : self.transaction.beneficiary.phoneOperatorCountryId,
              name:  self.transaction.beneficiary.phoneOperatorCountryId == 0 ? self.transaction.beneficiary.address.country : self.transaction.beneficiary.phoneCountryIDDCode
            });
            self.setHomeNo(self.transaction.beneficiary.phone);
            self.setMobileIDD({
              id: self.transaction.beneficiary.mobileOperatorCountryId == 0 ? self.transaction.homeCountryId : self.transaction.beneficiary.mobileOperatorCountryId,
              name: self.transaction.beneficiary.mobileOperatorCountryId == 0 ? self.transaction.beneficiary.address.country : self.transaction.beneficiary.mobileCountryIDDCode
            });
            self.setMobileNo(self.transaction.beneficiary.mobile);

            self.setPaymentPurpose({id: self.transaction.paymentPurposeId, name: self.transaction.paymentPurpose});
            self.setRefNo(self.transaction.beneficiaryBankNotes);
            self.setTransactionType({id: self.transaction.transactionTypeId, name: self.transaction.transactionType});

            console.log("deliveryMethodId",self.deliveryMethodId);
            console.log("beneficiaryName",self.beneficiaryName);
            console.log("identificationNo",self.identificationNo);
            console.log("identificationType",self.identificationType);
            console.log("homeCountry",self.homeCountryName);


            if(self.transaction.deliveryMethodId == 1 && self.transaction.bankTypeId == 1) {
              self.setDmExternalName(self.$t('general-text-dm-phil-gov'));
            } else if(self.transaction.deliveryMethodId == 1 && self.transaction.bankTypeId  == 2) {
              self.setDmExternalName(self.$t('general-text-dm-7'));
            } else if(self.transaction.deliveryMethodId == 6 && self.transaction.homeCountryId == 18) {
              self.setDmExternalName(self.$t('general-text-dm-bkash'));
            } else {
              self.setDmExternalName(self.$t('general-text-dm-' + self.deliveryMethodId));
            }

            self.isShowCancel                    = (self.settlementStatusId == 210) ? true : false;

          },

          async loadForm() {
            const self = this;
            self.showPreloader();

                const branchPromise = await this.$api.beneficiary.getRetailBranchDetails();
                const retailBranch  = branchPromise
                var raId            = retailBranch.retailAgentId;
                console.log(raId)

            // 3 - COLLECTION
            if(this.deliveryMethodId == 3) {

              // 18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA
              if(this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197) {
                const idTypePromise = await this.$api.beneficiary.getBeneficiaryIdType();
                self.setIdTypeList(idTypePromise);
              }

              // 18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA
              if(this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197) {
                const idTypePromise = await this.$api.beneficiary.getBeneficiaryIdType();
                self.setIdTypeList(idTypePromise);

                if(this.identificationType != '') {
                  Object.keys(self.idTypeList).forEach(key => {
                    if(self.idTypeList[key].toLowerCase() == self.identificationType.toLowerCase()) {
                      self.setIdTypeSelect({id: key, name: self.idTypeList[key]});
                    }
                  })
                }
              }
            }

            // 4 - DOOR TO DOOR || (3 - COLLECTION && 167 - PHILIPPINES)
            // || 1 - BANK TRANSFER && 13 - AUSTRALIA
            self.setProvinceList([]);
            if(this.deliveryMethodId == 4 || (this.deliveryMethodId == 3 && this.homeCountryId == 167)
              || (this.deliveryMethodId == 1 && this.homeCountryId == 13)
            ) {
                const provincePromise = await this.$api.beneficiary.getProvinceList(this.homeCountryId);
                self.setProvinceList(provincePromise);
            }

            // NOT BILL PAYMENT
            let paymentPurposeListTmp = []
            console.log("deliveryMethodId: " + this.deliveryMethodId);
            console.log("bankTypeId: " + this.bankTypeId);
            if(self.deliveryMethodId != 0) {
              let gender = self.$store.state.customer.gender
              if(gender.length<=0 || gender=== undefined){
                gender ="M"
              }
              let beneTypeId =self.$store.state.beneficiary.beneficiaryTypeId

              const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(self.homeCountryId, gender, beneTypeId);
              const ppList            = purposePromise

              Object.keys(ppList).forEach(key => {
                  paymentPurposeListTmp.push({key: key, value: ppList[key]})
              })

              // NOT INDIA
              if(this.homeCountryId != 98) {
                  paymentPurposeListTmp.push({key: -1, value: this.$t('beneficiary-other')})
              }

              self.setPaymentPurposeList(paymentPurposeListTmp);
              let ppIdTemp = 0;
              let ppNameTemp = "";

              console.log("paymentPurpose: " + this.paymentPurpose);
              console.log("paymentPurposeList: " + self.paymentPurposeList);
              if(this.paymentPurpose != '') {
                for(let i=0; i < this.paymentPurposeList.length; i++) {
                  let thisPP = this.paymentPurposeList[i];
                  if(thisPP.value.toLowerCase() == this.paymentPurpose.toLowerCase()) {
                    //this.paymentPurposeId = thisPP.key;
                      ppIdTemp = thisPP.key;
                      ppNameTemp = thisPP.value;
                      break;
                  } else {
                    //this.paymentPurposeId = -1;
                      ppIdTemp = -1;
                      ppNameTemp = "";
                  }
                }
              }
              self.setPaymentPurpose({id: ppIdTemp, name: ppNameTemp});
              console.log("paymentPurposeId: " + this.paymentPurposeId);

              let $$ = this.Dom7;
              if(self.paymentPurposeId == -1) {
                $$('select[name="paymentPurpose"]').closest('li').addClass('mb-0');

                self.setPaymentPurposeOther(ppNameTemp);
                self.setPaymentPurpose({id: -1, name: this.$t('beneficiary-other')});
              }

              const params = {
                ppId    : this.paymentPurposeId,
                ppOther : this.paymentPurposeOther
              }

              this.displayPaymentPurposeOther(params)
              this.setShowFormInputPaymentPurposeOther(store.state.transaction.isDisplayPaymentPurposeOther)
            }

            self.setCountryCodeList([]);
            const countryPromise = await this.$api.beneficiary.getCountryPhoneCodeList();
            self.setCountryCodeList(countryPromise)

            console.log("homeIDD: " + this.homeIDD);
            console.log("mobileIDD: " + this.mobileIDD);
            this.changeHomePhoneCode(this.homeIDD)
            this.changeMobilePhoneCode(this.mobileIDD)

            //console.log(self.transactionTypeId+" ### "+self.deliveryMethodId+" ### "+this.bankTypeId)
            let isWallet       = (self.transactionTypeId == 2 && self.deliveryMethodId == 1 && self.bankTypeId == 2) ? true : false
            if(isWallet){
              console.log("WALLET")
              store.state.transaction.showFormInput.root.walletNo = true
              store.state.transaction.showFormInput.root.bankAccountNo = false
            }else{
              console.log("NOT WALLET")
              store.state.transaction.showFormInput.root.walletNo = false
              store.state.transaction.showFormInput.root.bankAccountNo = store.state.transaction.isDisplayAccountNo.isDisplay
            }
            self.hidePreloader();
          },

          init() {
            const self    = this;

            self.f7Method = {
              confirmDialog: this.$f7.dialog.create({
                title   : this.$t('beneficiary-remove-title'),
                text    : this.$t('beneficiary-remove-notice'),
                buttons : [
                  {text: this.$t('general-text-btn-cancel'), cssClass: 'confirm-no', onClick: this.closeConfirmDialog},
                  {text: this.$t('general-text-btn-delete'), cssClass: 'confirm-yes', onClick: this.deactivateRecipient},
                ],
                on      : {
                  open: function () {
                      self.$$('.dialog.dialog-buttons-2').prepend("<span class='close-button'><span>");
                  },
                  opened: function() {
                      self.$$('.dialog.dialog-buttons-2 .close-button').on('click', function () {
                        self.closeConfirmDialog()
                      });
                  },
                  closed: function () {
                      self.$$('.dialog.dialog-buttons-2 .close-button').remove();
                  }
                }
              }),
            }
          },

          openConfirmDialog() {
            this.f7Method.confirmDialog.open();
          },

          closeConfirmDialog() {
            this.f7Method.confirmDialog.close();
          },

          setInput(inputEl){
            this.setInputState(inputEl, this.validateInputState.value)
          },

          finalValidateBeforeSave() {
            /*
              let isWallet       = (this.transactionTypeId == 2 && this.deliveryMethodId == 1 && this.bankTypeId == 2) ? true : false
            */
            console.log("FINAL : "+this.transactionTypeId+" ## "+this.deliveryMethodId+" ## "+this.bankTypeId)
            this.setIsFormInputValid(true);
            const params = {
              countryId : this.homeCountryId,
              txTypeId  : this.transactionTypeId,
              dmId      : this.deliveryMethodId,
              bankId    : this.bankId,
              bankTypeId: this.bankTypeId,
              name      : this.beneficiaryFullName,
              idType    : this.identificationType,
              idNo      : this.identificationNo,
              accountNo : this.bankAccountNo,
              accountName : this.bankAccountName,
              postcode  : this.postcode,
              refNo     : this.refNo,
              ppId      : this.paymentPurposeId,
              ppOther   : this.paymentPurposeOther,
              homeNo    : this.homeNo,
              homeIDD   : this.homeIDD,
              mobileNo  : this.mobileNo,
              mobileIDD : this.mobileIDD,
              email     : this.email,
            }

            let transactionState = store.state.transaction

            // BENEFICIARY NAME
            this.validateBeneficiaryName(params);
            let fullNameField = "beneficiaryName";
            this.setInputState(fullNameField, transactionState.isValidBeneficiaryName);
            this.setIsFormInputValid(transactionState.isValidBeneficiaryName == true ? true : false);
            if(!this.isFormInputValid) {
              return;
            }

            // NOT DOOR TO DOOR && NOT COLLECTION
            if(this.deliveryMethodId != 4 && this.deliveryMethodId != 3) {
              // ACCOUNT NUMBER
              this.validateAccountNo(params);
              this.setInputState("bankAccountNo", transactionState.isValidAccountNo);
              this.setIsFormInputValid(transactionState.isValidAccountNo == true ? true : false);
              if(!this.isFormInputValid) {
                return;
              }
            }

            // NOT BILL PAYMENT && NOT PHIL GOV SERVICE
            if(this.deliveryMethodId != 0 ) {
              // PURPOSE OF PAYMENT
              let paymentPurposeField = this.paymentPurposeId == -1 ? "paymentPurposeOther" : "paymentPurpose";
              this.finalValidatePaymentPurpose(paymentPurposeField, params);
              this.setIsFormInputValid(transactionState.isValidPaymentPurpose == true ? true : false);
              if(!this.isFormInputValid) {
                return;
              }
            }


            // HOME NUMBER
            this.finalValidateHomePhone(params);
            this.setIsFormInputValid(transactionState.isValidHomeNo == true ? true : false);
            if(!this.isFormInputValid) {
              return;
            }

            // MOBILE NUMBER
            this.finalValidateMobilePhone(params);
            this.setIsFormInputValid(transactionState.isValidMobileNo == true ? true : false);
            if(!this.isFormInputValid) {
              return;
            }

            // EMAIL
            this.validateEmail(params);
            this.setInputState("email", transactionState.isValidEmail);
            this.setIsFormInputValid(transactionState.isValidEmail == true ? true : false);
            if(!this.isFormInputValid) {
              return;
            }


            // 4 - DOOR TO DOOR || 3 - COLLECTION
            if(this.deliveryMethodId == 4 || this.deliveryMethodId == 3) {
              // IDENTIFICATION TYPE
              // 3 - COLLECTION && (18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA (SELECT), OTHER TEXT)
              if(this.deliveryMethodId == 3
                    && (this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197)
              ) {
                  this.validateIdTypeSelect(this.idTypeSelectId);
                  this.setInputState("idTypeSelect", transactionState.isValidIdTypeSelect);
                  this.setIsFormInputValid(transactionState.isValidIdTypeSelect == true ? true : false);
                  if(!this.isFormInputValid) {
                    return;
                  }
              } else {
                  this.validateIdentificationType(params);
                  this.setInputState("identificationType", transactionState.isValidIdType);
                  this.setIsFormInputValid(transactionState.isValidIdType == true ? true : false);
                  if(!this.isFormInputValid) {
                    return;
                  }
              }

              // IDENTIFICATION NUMBER
              this.validateIdentificationNo(params);
              this.setInputState("identificationNo", transactionState.isValidIdNo);
              this.setIsFormInputValid(transactionState.isValidIdNo == true ? true : false);
              if(!this.isFormInputValid) {
                return;
              }
            }

            // REF NO
            this.validateRefNote(params);
            this.setInputState("refNo", transactionState.isValidRefNo);
            this.setIsFormInputValid(transactionState.isValidRefNo == true ? true : false);
            if(!this.isFormInputValid) {
              return;
            }

            // 4 - DOOR TO DOOR
            if(this.deliveryMethodId == 4 ) {
              // POSTCODE
              this.finalValidatePostcode("postcode", params)
              this.setIsFormInputValid(transactionState.isValidPostcode.inputState == true ? true : false);
              if(!this.isFormInputValid) {
                return;
              }

              // STREET
              this.validateStreet(this.street);
              this.setInputState("street", transactionState.isValidStreet);
              this.setIsFormInputValid(transactionState.isValidStreet == true ? true : false);
              if(!this.isFormInputValid) {
                return;
              }
            }

            return this.isFormInputValid
          },

          setPayload(){
            var payload = {
                "transactionId"                       : self.transactionId,
                "beneficiaryName"                     : self.beneficiaryName,
                "beneficiaryHomePhone"                : self.homeNo,
                "beneficiaryMobilePhone"              : self.mobileNo,
                "email"                               : self.email,
                "paymentPurpose"                      : self.paymentPurpose,
                "accountNo"                           : self.accountNo,
                "refNo"                               : self.refNo,
                "cashCardNo"                          : self.accountNo,
                "bankAccountName"                     : self.bankAccountName,
                "beneficiaryHomePhoneCountryId"       : self.homeIDD,
                "beneficiaryMobilePhoneCountryId"     : self.mobileIDD,
                "beneficiaryTypeId"                   : self.beneficiaryTypeId,
                "beneficiaryIdNumber"                 : self.identificationNo,
                "beneficiaryIdType"                   : self.identificationType,
                "updateBene"                          : true,
                "address":{

                    "streetAddress"                   : self.street,
                    "postcode"                        : self.postalCode,
                    "cityId"                          : "",
                    "city"                            : "",
                    "provinceId"                      : "",
                    "province"                        : "",
                    "provinceCode"                    : "",
                    "countryId"                       : self.homeCountryId,
                    "country"                         : self.homeCountry,
                    "countryISOCode2"                 : "",
                    "countryISOCode3"                 : "",
                    "buildingNumber"                  : self.locatingNote,
                    "streetName"                      : self.street,
                    "buildingName"                    : self.landmark,
                    "unitNumber"                      : self.locatingNote,

                },
            }

            return payload;
          },

          async modifyTransaction() {
            const self = this;
            self.showPreloader();

            //const transactionData = store.state.transaction;
            //var params = this.setPayload()

            //this.showAlert(false);

            console.log("this.finalValidateBeforeSave() : "+this.isFormInputValid);
            if(!this.isFormInputValid) {
              this.hidePreloader();
              return;
            }


            var updateData = store.state.misc;

            self.$api.otp.requestotp(2).then(function(result) {
              self.hidePreloader();
              if(result.status) {
                updateData.otp.routerTo = 'modifyTransaction';
                self.$f7router.navigate("/otp");
              } else {
                self.$f7.dialog.alert(result.message);
              }
            });

          },

          cancelTransaction(){
            const self = this
            try {
              self.showPreloader()
              const cancelTransactionRequest = self.$api.transaction.cancelTransaction( self.transaction.transactionId, self.transaction.transactionTypeId )
              cancelTransactionRequest.then(function(result) {
                if(!result.invalid){
                  //self.forceRerenderTrxJourneyComp()
                  self.$f7router.navigate("/transaction-history"                      , { props: { isTrxCancelled: true }});                        console.log("cancelTransactionRequest" ,result)
                }else{
                  console.log("cancelTransactionRequest" ,result)
                }
                self.showCancelTrxModal = false
                self.hidePreloader()
              });

            } catch(e){
              self.hidePreloader()
            }
          },


          showAlert(status, title, content) {
            this.alertCard.show = status;
            if(title == undefined) {
                title = "";
            } else {
                title = this.$t(title);
            }

            if(content == undefined) {
                content = "";
            } else {
                content = this.$t(content);
            }
            this.alertCard.title   = title;
            this.alertCard.content = content;
          },

          formatCurrency(num, dec) {
            let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          },

          backButton() {

            const self = this

            //RESET TRANSACTION DATA WITH VALUES FROM API
            self.initializeValues();

            this.$f7router.back({ transition: 'f7-push' });

          }
      }
  }
</script>